import Vue from 'vue'
import Vuex from 'vuex'
import accordion from './modules/accordion';
import artists from './modules/artists'
import cart from './modules/shopping-cart';
import gridListFilters from './modules/grid-list-filters'
import globalSearch from './modules/global-search'
import intersect from './modules/intersect'
import modal from './modules/modal'
import notifications from './modules/notifications'
import profile from './modules/profile'
import playlists from './modules/playlists'
import player from './modules/Player'
import productModal from './modules/product-modal'
import giftModal from './modules/gift-modal'
import subscription from './modules/subscription'
import stripeCustomer from './modules/stripe-customer'
import user from './modules/user'
import checkout from './modules/checkout'
import addresses from './modules/addresses'
import cards from './modules/cards'
import countries from "./modules/countries";
import coupons from "./modules/coupons";
import plans from "./modules/plans";
import recaptcha from "./modules/recaptcha";
import zerobounce from "./modules/zerobounce";
import overridePreview from './modules/override-preview'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        accordion,
        cart,
        profile,
        globalSearch,
        intersect,
        modal,
        artists,
        stripeCustomer,
        user,
        subscription,
        notifications,
        playlists,
        productModal,
        gridListFilters,
        player,
        checkout,
        addresses,
        cards,
        countries,
        coupons,
        plans,
        giftModal,
        recaptcha,
        zerobounce,
        overridePreview,
    },
    strict: debug,
})
